import React from 'react'
import { Statistic } from 'semantic-ui-react'
import { connect } from 'react-redux'

const NumPlayers = ({ numPlayers }) => (
    <Statistic label='Spettatori connessi' value={numPlayers} />
)

const mapStateToProps = (state) => ({
    numPlayers: state.numPlayers
})

export default connect(
    mapStateToProps
)(NumPlayers)



// WEBPACK FOOTER //
// ./src/components/NumPlayers.js